
import Vue from 'vue';

import * as RootStore from '@/store/search/';
import * as GlobalViewSettings from '@/store/search/results/global';
import * as ResultsViewSettings from '@/store/search/results/views';

import SelectPicker,{ Option } from '@/components/SelectPicker.vue';
import Modal from '@/components/Modal.vue';

import debug from '@/utils/debug';
import { localStorageSynced } from '@/utils/localstore';

export default Vue.extend({
	components: {
		SelectPicker,
		Modal
	},
	data: () => ({
		debug,
		wideView: localStorageSynced('cf/wideView', false),
	}),
	computed: {
		viewedResultsSettings: RootStore.get.viewedResultsSettings,
		pageSize: {
			get(): string { return this.itoa(GlobalViewSettings.getState().pageSize); },
			set(v: string) {
				GlobalViewSettings.actions.pageSize(this.atoi(v)!);
				ResultsViewSettings.actions.resetPage();
			}
		},
		pageSizeOptions(): Option[] {
			return ['20','50','100','200'].map(value => ({
				value,
				label: this.$t('setting.resultsPerPageOption', { n: value }).toString()
			}));
		},
		sampleMode: {
			get() { return GlobalViewSettings.getState().sampleMode; },
			set(v: GlobalViewSettings.ModuleRootState['sampleMode']) {
				GlobalViewSettings.actions.sampleMode(v);
				ResultsViewSettings.actions.resetPage();
			}
		},
		sampleModeOptions(): Option[] {
			return [{
				value: 'percentage',
				label: this.$t('setting.sampleSizePercentage').toString(),
			}, {
				value: 'count',
				label: this.$t('setting.sampleSizeCount').toString(),
			}]
		},
		sampleSize: {
			get(): string { return this.itoa(GlobalViewSettings.getState().sampleSize); },
			set(v: string) {
				GlobalViewSettings.actions.sampleSize(this.atoi(v));
				ResultsViewSettings.actions.resetPage();
			}
		},
		sampleSeed: {
			get(): string { return this.itoa(GlobalViewSettings.getState().sampleSeed); },
			set(v: string) {
				GlobalViewSettings.actions.sampleSeed(this.atoi(v));
				if (this.viewedResultsSettings && this.viewedResultsSettings.groupBy.length) {
					// No need to do this when ungrouped - the raw number of results
					// will stay as it is, but the distribution (and number of) groups may change and
					// cause the number of pages to shift
					ResultsViewSettings.actions.resetPage();
				}
			}
		},
		context: {
			// context can be a string or number in BlackLab, but for now in the form we only allow numbers.
			// hence the atoi so BlackLab receives a number
			// the .value interface of html input field only deals in strings...
			get(): string {
				const c = GlobalViewSettings.getState().context;
				return c != null ? c.toString() : '';
			},
			set(v: string) { GlobalViewSettings.actions.context(this.atoi(v)); }
		},
	},
	methods: {
		focusSampleSize() {
			(this.$refs.sampleSize as HTMLInputElement).focus()
		},
		itoa(n: number|null): string { return n == null ? '' : n.toString(); },
		atoi(s: string): number|null { return s ? Number.parseInt(s, 10) : null; }
	},
	watch: {
		'wideView.value': {
			immediate: true,
			handler(v: boolean) {
				$('.container, .container-fluid').toggleClass('container', !v).toggleClass('container-fluid', v);
			},
		}
	}
})
